import React, { useRef } from 'react';
import { useConfirm } from './ConfirmContext';

import { ReactComponent as Spinner } from './images/spinner.svg';

const ObfuscatedCode = () => {
  const confirm = useConfirm();

  let [message, setMessage] = React.useState('The obfuscated code will appear here');
  let [result, setResult] = React.useState('');

  let textRef = useRef(null);

  const obfuscateCode = async () => {
    const code = textRef.current.value;

    setMessage(null);
    setResult(<Spinner style={{
                         width: '40px',
                         height: '40px',
                         animation: 'spin 1s linear infinite',
                       }} />);

    if (code) {
      fetch(process.env.REACT_APP_SERVER_URL + '/api/obfuscate-code', {
        method: 'POST',
        headers: {
          'Authorization': localStorage.getItem('token'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ input: code }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            setMessage('Obfuscated code ready! Click to copy it to clipboard.');
            setResult(<pre style={{ fontFamily: 'monospace',
                                    whiteSpace: 'pre-wrap',
                                    color: 'gray',
                                    fontFamily: 'monospace',
                                    fontSize: '20px',
                                  }}
                           onClick={async () => {
                             navigator.clipboard.writeText(data.output);
                             confirm('Obfuscated code copied to clipboard!', true);
                           }}>
                        <code>
                          {data.output}
                        </code>
                      </pre>);
          }
          else {
            setMessage('Error obfuscating:');
            setResult(<pre style={{ fontFamily: 'monospace',
                                    whiteSpace: 'pre-wrap',
                                    color: 'red',
                                    fontFamily: 'monospace',
                                    fontSize: '20px',
                                  }}>
                        <code>
                          {data.output}
                        </code>
                      </pre>);
          }
        })
        .catch(error => console.log(error));
    } else {
      await confirm('Please paste some code to obfuscate', true);
    }
  };

  return (
    <div style={{display: 'flex',
                 flexDirection: 'column',
                 padding: '20px',
                 overflow: 'auto',
                 height: 'calc(100vh - 150px)',
                }}>
      <h3>Please paste the code to obfuscate:</h3>
      <textarea
        rows="10"
        placeholder="Paste your code here..."
        ref={textRef}
        style={{
          fontSize: '20px',
          fontFamily: 'monospace',
          color: 'white',
          backgroundColor: 'black',
          border: '1px solid gray',
          padding: '10px',
          resize: 'none',
          minHeight: '200px',
        }}
      />
      <button style={{padding: '10px 20px',
                      fontSize: '20px',
                      marginTop: '10px',
                      width: 'fit-content',
                     }}
              onClick={() => obfuscateCode()}>
        Obfuscate
      </button>

      {message && (
        <p style={{color: 'white', fontSize: '20px', marginTop: '10px'}}>
          {message}
        </p>
      )}

      {result && (
        <div style={{marginTop: '20px'}}>
          {result}
        </div>
      )}
    </div>
  );
}

export default ObfuscatedCode;
